export default {
    accept_another_payment: "Дагы төлөмдү кабыл алуу",
    active_plan_treatments: "Активдүү дарылоо пландары",
    activity: "Активдүүлүк",
    add_complex: "Комплексти кошуу",
    add_diagnosis: "Диагнозду кошуу",
    add_question: "Суроону кошуу",
    add_service: "Кызматты кошуу",
    add_tooth_jaw: "Тишти кошуу / жаакты",
    add_visit: "Визитти кошуу",
    added_by: "Ким тарабынан кошулган",
    additional_discount: "Кошумча арзандатуу",
    age: "Жашы",
    agreement: "Макулдук",
    akt_of_services_for_period: "Мезгил ичинде көрсөтүлгөн кызматтардын актысы",
    akt_print: "Акттын мөөрү",
    allergic_reactions: "Аллергиялык реакциялар",
    allergies: "Аллергиялар",
    allergy_diagnosis: "Аллергологиялык диагноз",
    anamnesis: "Стоматологиялык анамнез",
    anketa_footer: "Анкетанын футери",
    anketa_header: "Анкетанын башы",
    anketa_texts: "Анкеталарлын тексти",
    applied: "Колдонулган",
    applied_complex: "Колдонулган комплекс",
    apply_to_teeth: "Тиштерге колдонуу",
    apply_to_whole_tooth: "Бүт тишке колдонуу",
    apply_treatment_template: "Дарылоо шаблонун колдонуу",
    are_you_sure_to_set_plan: "Дарылоо картасын планга байланыштыргыңыз келеби - толтурулган карта талаалары кайра жазылышы мүмкүнбү?",
    are_you_sure_you_want_to_delete_document: "Сиз чындыгында документти жок кылгыңыз келеби?",
    are_you_sure_you_want_to_delete_payment: "Сиз чындыгында төлөмдү алып салгыңыз келеби?",
    are_you_sure_you_want_to_delete_scan: "Сиз чындыгында скандоону жок кылгыңыз келеби?",
    are_you_sure_you_want_to_delete_status: "Сиз чындыгында статусту алып салгыңыз келеби?",
    are_you_sure_you_want_to_delete_transaction: "Сиз чындыгында транзакцияны алып салгыңыз келеби?",
    are_you_sure_you_want_to_delete_user: "Сиз чындыгында колдонуучуну алып салгыңыз келеби?",
    are_you_sure_you_want_to_delete_users: "Сиз чындыгында колдонуучуларды алып салгыңыз келеби?",
    ask_result_on_saving: "Сактоодо визиттин натыйжасын суроо",
    assistant: "Жардамчы",
    attach_new_user: "Жаңы колдонуучуну байлап коюу",
    author: "Автор",
    available: "Жеткиликтүү",
    baby_teeth: "Сүт тиштер",
    baby_teeth_short: "Сүт",
    balance_refill: "Депозитти толуктоо",
    balance_writeoff: "Депозитти эсептен чыгаруу",
    birthdays: "Туулган күндөр",
    bite: "Жаактын кабышы",
    bottom_baby_teeth: "Астыңкы сүт тиштер",
    bottom_jaw: "Астыңкы жаак",
    bottom_molars: "Астыңкы азуу тиштер",
    by_complexes: "Комплекстер боюнча",
    by_doctors: "Дарыгерлер боюнча",
    call: "Чалуу",
    came: "Келди",
    came_from: "Кайдан келди",
    can_be_paid_with_bonuses: "Бонустар менен төлөөгө болот",
    can_be_written_off: "Жазылса болот",
    cancel_initiator: "Жокко чыгаруунун демилгечиси",
    cancelled: "Жокко чыгарылды",
    card: "Карточка",
    card_number: "Карточканын номери",
    card_transfer: "Картага которуу",
    cash: "Накталай",
    cashless: "Накталай эмес",
    choose_document_type_and_its_parameters: "Документтин түрүн жана анын параметрлерин тандаңыз",
    choose_patient: "Бейтапты тандаңыз",
    choose_signer: "Кол коюучуну тандаңыз",
    choose_treatment_template: "Дарылоо шаблонун тандаңыз",
    client: "Бейтап",
    client_document: "Бейтаптын документи",
    client_id: "Бейтап",
    client_note: "Эскертүү",
    client_service: "Кардарларды тейлөө",
    code: "Код",
    color: "Түс",
    combine_user_note: "Бейтапты тандап жана \"биригүү\" баскычын басуу менен сиз визиттер, төлөмдөр, диагноздор жана башкалар боюнча бардык маалыматтарды тандалган бейтаптын картасына өткөрүп бересиз. Учурдагы бейтаптын картасы өчүрүлөт. Биригүү процедурасын артка кайтарууга болбойт.",
    comment_to_phone: "Телефонго комментарий",
    comment_to_phone_2: "Кошумча телефонго комментарий",
    complaints: "Даттануулар",
    complex: "Комплекс",
    complexes: "Комплекстер",
    condition: "Абал",
    confirm_tag_deletion: "Сиз чындыгында белгини алып салгыңыз келеби?",
    confirmed: "Тастыкталган",
    confirmed_male: "Тастыкталган",
    consultation: "Кеңеш",
    contract: "Келишим",
    contract_agreement: "Макулдук келишими",
    contract_general: "Жалпы келишим",
    contract_print: "Келишимдин мөөрү",
    contract_services: "Кызмат көрсөтүү келишими",
    create_diagnosis: "Диагнозду түзүү",
    creation_date: "Түзүүнүн датасы",
    date: "Дата",
    date_add: "Түзүлдү",
    date_from: "Дата  баштап",
    date_of_birth: "Туулган күнү",
    date_of_birth_month_day: "Туулган датасы (күн жана айы)",
    date_to: "Дата  чейин",
    dates_not_selected: "Даталар тандалган жок",
    debt: "Карыз",
    debt_cancellation: "Карызды жокко чыгаруу",
    delete_complex: "Комплексти жокко чыгаруу",
    delete_visit: "Визитти жокко чыгаруу",
    department_code: "Бөлүмдүн коду",
    deposit: "Депозит",
    description: "Сыпаттама",
    desired_date_from: "Каалаган датасы  баштап",
    desired_date_to: "Каалаган датасы  чейин",
    desired_time_from: "Каалаган убакыт  баштап",
    desired_time_to: "Каалаган убакыт  чейин",
    detailed_information: "Толук маалымат",
    diagnoses: "Диагноздор",
    diagnosis: "Диагноз",
    diary: "Күндөлүк",
    did_not_come: "Келген жок",
    discount: "Арзандатуу",
    disease_anamnez: "Ооруунун анамнези (учурдагы оорунун өнүгүшү)",
    disease_anamnez_short: "Оорунун тарыхы",
    disease_development: "Учурдагы оорунун өнүгүшү",
    disease_history: "Ооруунун тарыхы",
    diseases_passed_and_current: "Мурунку жана коштоочу оорулар",
    doctor: "Дарыгер",
    document: "Документ",
    document_number: "Документтин номери",
    document_type: "Документтин түрү",
    does_not_participate: "Катышпайт",
    drag_file_here_or_select: "Файлды бул жерге жылдырыңыз же тандаңыз",
    edit_questionnaire: "Анкетаны өзгөртүү",
    electronic_cheque: "Электрондук чек",
    enter_the_title: "Атын киргизиңиз",
    epikriz: "Эпикриз",
    examination_plan: "Текшерүү планы",
    f043: "Ф 043",
    f37u78: "037/У-88 формасы",
    f43kaz: "043/КАЗ формасы",
    f43rus: "043/РФ формасы",
    f43ukr: "043/У формасы",
    f58kaz: "058/КАЗ формасы",
    family_account: "Үй-бүлөлүк эсеп",
    female: "Аял",
    female_short: "Аял",
    fill_anamnez_from_previous_visits: "Мурунку визиттердеги анамнезди толтуруңуз",
    fill_balance: "Депозитти толуктоо",
    filling: "Толуктоо",
    finish_visit: "Кабыл алууну аяктоо",
    fio: "Аты-жөнү",
    first_visit: "Биринчи визит",
    fiscal_cheque: "Фискалдык чек",
    for_female_patients: "Бейтаптар үчүн",
    formula: "Формула",
    formula_selection_instructions: "Жогорку көрүнүш: чычкандын сол баскычын басып туруп, тиштин керектүү жерлерине сүйрөңүз.",
    foto_link_note: "Сүрөттү жүктөөдөн тышкары, сүрөттүн коомдук шилтемесин көрсөтсө болот",
    from_account: "Эсептен",
    full_card: "Толук карточка",
    gender: "Жынысы",
    general_info: "Негизги маалымат",
    how_to_use: "Кантип колдонуу керек?",
    hygiene: "Гигиена",
    hygiene_index: "Гигиенанын индекси",
    iin: "ЖИН",
    importance: "Маанилүүлүк",
    important: "Маанилүү",
    in_chair: "Креслодо",
    in_process: "Иштетилүүдө",
    include_in_f043: "043 формасына кошуу",
    include_in_f043f058: "043 / 058 формасына кошуу",
    include_in_f058: "058 формасына кошуу",
    inn: "ЖСТН",
    inspection: "Сырткы текшерүү",
    insurance: "Камсыздандыруу",
    invoice_print: "Эсепти басып чыгаруу",
    is_deleted: "Өчүрүлгөн",
    issue_date: "Берилген күнү",
    issued_by: "Ким тарабынан берилген",
    jaws: "Жаактар",
    kpu_index: "КПА индекси",
    last_visit: "Акыркы визит",
    left_due: "Калдык",
    life_anamnez: "Жашоо анамнези",
    link: "Шилтеме",
    link_to_call_record: "Сүйлөшүүнү жаздырууга шилтеме",
    listen: "Угуу",
    live_feed: "Жандуу  лента",
    lost: "Жоголду",
    make_payment: "Төлөмдү которуу",
    male: "Эркек",
    male_short: "Эркек",
    manual_status: "Кол менен статус",
    medication: "Дарылоо",
    middle_name: "Атасынын аты",
    mkb_code: "ОЭАК коду",
    move_to_visit: "Визитке өтүү",
    mphone: "Телефон",
    ndfl_statement: "ЖКС аныктамасы",
    ndfl_statement_new: "ЖКС аныктамасы (жаңы)",
    ndfl_statement_xml: "ЖКС аныктамасы (XML)",
    new: "Жаңы",
    new_patient: "Биринчи бейтап",
    new_patients_automatically_participate_in_bonus_system: "Жаңы пациенттер автоматтык түрдө бонустук системага катышат",
    next_visit: "Кийинки визит",
    no_attachment: "Жүктөө жок",
    no_complexes: "Комплекстер жок",
    no_teeth_in_the_record: "Жазылууда бир дагы тиш көрсөтүлгөн эмес",
    norm: "Норма",
    not_confirmed: "Тастыкталган эмес",
    note: "Эскертүү",
    notes: "Эскертүүлөр",
    objectively: "Объективдүү",
    on_week: "Жумада",
    one_visit_that_came: "Бир иш сапары аяктады",
    or_write_other_reason: "же башка себепти көрсөтүңүз",
    oral_cavity: "Ооз көңдөйү",
    ortodentic_formula: "Ортодонтиялык формула",
    ortodentic_formula_ru: "Ортодонтиялык формула (РФ)",
    other: "Башка",
    overpayment: "Ашыкча төлөм",
    paid: "Төлөндү",
    participate_in_bonus_program: "Бонустук системага катышат",
    passive: "Пассивдүү",
    passport: "Паспорт",
    passport_data: "Паспорт маалыматтары",
    passport_number: "Паспорттун номери",
    password_validation_error: "Жашырынсөз кеминде 8 белгиден, жок дегенде бир чоң тамгадан, жок дегенде бир сандан жана жок дегенде бир өзгөчө белгиден турушу керек.",
    patient: "Бейтап",
    patient_condition_id: "Абал",
    patient_deleted: "Бейтап жокко чыгарылды",
    patient_did_not_come: "Бейтап келген жок",
    patient_fio: "Бейтаптын аты-жөнү",
    patient_has_important_notes: "Бейтаптын маанилүү эскертүүлөрү: {cnt}",
    patient_number: "Бейтаптын номери",
    patient_phone: "Бейтаптын телефону",
    patient_source: "Кайдан келди",
    patient_with_such_name_exists: "Ушундай эле аттагы пациент маалымат базасында мурунтан эле бар",
    payment: "Төлөм",
    payment_accepted: "Төлөм кабыл алынды",
    payment_date: "Төлөмдүн датасы",
    payment_form: "Төлөмдүн формасы",
    payment_from: "дан төлөм",
    payment_history: "Төлөмдөрдүн тарыхы",
    payment_processing: "Төлөм жүргүзүү",
    payment_type: "Төлөм ыкмасы",
    payments: "Төлөмдөр",
    permanent: "Туруктуу",
    permanent_teeth: "Туруктуу тиштер",
    permanent_teeth_short: "Туруктуу",
    personal_data: "Жеке маалымат",
    pesel: "PESEL",
    phone_2: "Кош. телефон",
    pin: "Тиркөө",
    pinned: "Тиркелди",
    plan_fact: "План / Факт",
    plan_notification: "Билдирүүнү пландаштыруу",
    planned_result: "Пландаштырылган натыйжа",
    planned_send_date: "Пландаштырылган жөнөтүү күнү",
    planned_services: "Пландаштырылган процедуралар",
    planned_treatment: "Пландаштырылган дарылоо",
    preliminary: "Алдын ала",
    preliminary_diagnosis: "Алдын ала диагноз",
    price_price: "Прайс",
    prices_price: "Прайстар",
    print_empty: "Мөөр бош",
    process: "Жүргүзүү",
    question: "Суроо",
    questionnaire: "Анкета",
    quick_card: "Тез карточка",
    receipt: "Квитанция",
    recommendations: "Сунуштар",
    record: "Жазылуу",
    record_not_available: "Жазылуу жеткиликтүү эмес",
    recorded: "Жазылды",
    refresh_prices: "Бааларды жаңыртуу",
    refresh_prices_and_materials: "Бааларды жана материалдарды жаңыртуу",
    region: "Область",
    regular_client: "Туруктуу бейтап",
    rejected: "Баш тартты",
    reopen_visit: "Кабыл алууну кайра ачуу",
    representative: "Өкүлдүн аты-жөнү",
    representative_address: "Өкүлдүн дареги",
    representative_document: "Бейтаптын өкүлү болуу укугун күбөлөндүргөн документтин реквизиттери",
    representative_document_number: "Өкүлдүн документинин номери",
    representative_document_type: "Өкүлдүн документинин түрү",
    representative_id: "Бейтаптар тизмесинен өкүл",
    representative_inn: "Өкүлдүн ЖСТН",
    representative_noun: "Өкүл",
    representative_passport: "Өкүлдүн паспортунун номери",
    representative_passport_data: "Өкүлдүн паспорттук маалыматтары",
    representative_phone: "Өкүлдүн телефону",
    request_snils: "ЖКЭН суроо",
    request_snils_note: "ССЧБММС тарабынан ЖКЭН алуу - Бул үчүн сиз бейтаптын толук аты-жөнүн, жынысын, туулган датасын жана паспорттун реквизиттерин (түрү, сериясы, номери, берилген датасы жана ким тарабынан берилген) толтуруу керек",
    restore: "Калыбына келтирүү",
    result: "Натыйжа",
    results_not_found: "Натыйжа табылган жок",
    results_of_xray_and_lab_research: "Рентген, лабораториялык изилдөөлөрдүн маалыматтары",
    save_and_close: "Сактоо жана жабуу",
    save_as_template: "Шаблон катары сактоо",
    save_as_treatment_template: "Дарылоо шаблону катары сактоо",
    scan: "Сүрөт",
    scans: "Сүрөттөр",
    select_document_type: "Документтин түрүн тандаңыз",
    select_visit: "Визитти тандаңыз",
    selected_teeth: "Тандалган тиштер",
    send: "Жөнөтүү",
    send_link_to_patient: "Шилтемени бейтапка жөнөтүү",
    send_mail: "Кат жөнөтүү",
    send_marketing: "Маркетинг электрондук каттарын жөнөтүү",
    send_message: "Кат жөнөтүү",
    send_notifications: "Билдирме жөнөтүү",
    send_password_to_patient: "Бейтапка жащырынсөз жөнөтүү",
    send_to_laboratory_via_whatsapp: "Лабораторияларды WhatsApp аркылуу жөнөтүү",
    send_to_patient_via_max: "Макс аркылуу бейтапка жөнөтүү",
    send_to_patient_via_messenger: "Пациентке мессенжер аркылуу жөнөтүңүз",
    send_to_patient_via_telegram: "Бейтапка Telegram аркылуу жөнөтүңүз",
    send_to_patient_via_telegram_bot: "Бейтапка Telegram боту аркылуу жөнөтүү",
    send_to_patient_via_whatsapp: "Бейтапка WhatsApp аркылуу жөнөтүү",
    send_try: "Жөнөтүү аракети",
    series: "Серия",
    service: "Кызмат",
    services_payment_from: "Көрсөтүлгөн кызматтардын төлөмү",
    set_the_amount: "Санын көрсөтүү",
    short_name: "Кыска аталыш",
    size: "Көлөм",
    sms_available: "СМС жеткиликтүү",
    sms_sending: "СМС жөнөтүү",
    snils: "ЖЭКН",
    sorting_instructions: "Чычканыңыз менен саптарды жылдырып, аларды керектүү тартипте жайгаштырыңыз",
    standard: "Стандарт",
    start_treatment: "Дарылоону баштоо",
    start_visit: "Кабыл алууну баштоо",
    stopped: "Токтотулду",
    subjectively: "Субъективдүү",
    such_patient_already_exists_in_database: "Бейтап мурунтан эле маалымат базасында бар",
    sum_with_discount: "Арзандатылган сумма",
    superadministrator: "Суперадминистратор",
    surname: "Фамилия",
    symbols_amount: "Символдордун саны",
    tags_for_contract: "Маалыматты автоматтык түрдө көрсөтүү үчүн тэгдер:",
    tags_for_document: "Маалыматты автоматтык түрдө көрсөтүү үчүн тэгдер:",
    teeth: "Тиштер",
    teeth_card: "Тиш картасы",
    teeth_selection_instructions: "<b>Бир нече тиш</b>ди тандоо үчүн Shift баскычын басып туруп, керектүү тиштерди басыңыз. <b>Жаңы топ</b> үчүн Shift баскычын коё берип, кайра кармап туруңуз. <b>Бир тиш</b> кадимки басуу менен тандалат.",
    teeth_vertical_selection_instructions: "<b>Жогорку көрүнүш:</b> чычкандын сол баскычын басып туруп, тиштин керектүү жерлерине сүйрөңүз.",
    termometry: "Термометрия",
    there_were_no_payments: "Азырынча төлөмдөр болгон жок",
    this_phone_is_in_system: "Бул номер базада мурунтан эле бар",
    to_account: "Эсепке",
    to_add_diagnoses_you_need_to_select_teeth: "Диагноздорду кошуу үчүн тиштерди тандоо керек",
    to_add_services_you_need_to_select_teeth: "Кызматтарды кошуу үчүн тиштерди тандоо керек",
    to_pay_with_bonus: "Бонустар менен төлөө",
    to_whom: "Кимге",
    together_with_tooth_all_the_related_services_and_materials_will_be_deleted: "Тиш менен бирге тиешелүү кызматтар, материалдар жана диагноздор алынып салынат. Ырастообу?",
    tonometry: "Тонометрия",
    tooth: "Тиш",
    tooth_formula: "Тиш формуласы",
    tooth_is_assigned: "Тишти алып салуу мүмкүн эмес, анткени ага кызмат көрсөтүүлөр же диагноздор мурунтан эле байланышкан",
    top_baby_teeth: "Үстүңкү сүт тиштер",
    top_jaw: "Үстүңкү жаак",
    top_molars: "Үстүңкү азуу тиштер",
    topic: "Тема",
    total_paid: "Бардыгы төлөндү",
    total_paid_for_treatment_plan: "Дарылоо планына ылайык кызматтар үчүн акы төлөндү",
    total_services_selected: "Тандалган кызматтардын жалпы саны",
    total_to_pay: "Бардыгы төлөөгө",
    total_with_discount: "Бардыгы арзандатуу менен",
    transfer_between_patient_accounts: "Бейтаптын эсептери ортосунда которуу",
    transfer_whole_amount: "Толук сумманы которуу",
    treating_doctor: "Дарылоочу дарыгер",
    treatment: "Дарылоо",
    treatment_card: "Дарылоо карточкасы",
    treatment_complete: "Дарылоо аяктады",
    treatment_history: "Дарылоо тарыхы",
    treatment_plan: "Дарылоо планы",
    treatment_template: "Дарылоо шаблону",
    un: "д.",
    unify: "Бириктирүү",
    unify_card: "Карточканы бириктирүү",
    unpaid: "Төлөнбөгөн",
    unpin: "Бошотуу",
    upload_date: "Жүктөө күнү",
    used_medication: "Кабыл алынуучу дары-дармектер",
    user_attached_to_family_account: "Колдонуучу үй-бүлөлүк эсепке байланган",
    users_attached_to_user_family_account: "Колдонуучунун үй-бүлөлүк эсебине байланган бейтаптар",
    visit: "Визит",
    visit_date: "Визиттин датасы",
    visit_description_doctor: "Дарыгердин визитинин сүрөттөлүшү",
    visit_duration: "Визиттин узактыгы (мин)",
    visit_finished: "Кабыл алуу аяктады",
    visit_in_progress: "Кабыл алуу жүрүп жатат",
    visit_started: "Кабыл алуу башталды",
    visit_time: "Визиттин убактысы",
    visits: "Визиттер",
    waiting: "Күтүүдө",
    waiting_list: "Күтүү тизмеси",
    with_formula: "Формула менен",
    without_payment: "Төлөмсүз",
    write_reason: "Себебин айтыңыз",
    xray: "Рентген",
    years: "Жаш",
    you_need_to_select_teeth: "Сиз тиштерди тандашыңыз керек",
    zipcode: "Почта индекси"
}
